import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import TeletelAdvisorIndex from './Index.vue';

// The manager advisor (owner plan 2026-09-14, phase 1): a read-only chat
// that explains how to organise the account, on the assistant feature and
// permission.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/teletel-advisor'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'teletel_advisor',
          meta: {
            permissions: ['administrator', 'assistant_manage'],
          },
          component: TeletelAdvisorIndex,
        },
      ],
    },
  ],
};
